import React from "react";
import { render } from "react-dom";
import ProductRating from "../widgets/productrating";

let ratingEls = document.querySelectorAll(".product-rating");
if (ratingEls.length)
    ratingEls.forEach(el => render(<ProductRating {...el.dataset} />, el));
